import styled from 'styled-components'

const ImageDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const Image = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 100%;
  max-height: 100%;
  border: solid 1px #979797;
  margin-bottom: 5vh;
`

type PhotoPreviewProps = {
  id: string
  alt?: string
  src?: string
  handleClose(): void
}

const PhotoPreview = ({ alt, src, handleClose, id }: PhotoPreviewProps) => (
  <div
    role="dialog"
    data-backdrop-close="false"
    className="tds-modal tds-modal__dialog--medium"
    id={ id }
    hidden
  >
    <div
      role="document"
      className="tds-modal__dialog-container"
      aria-labelledby={ id + '-heading' }
    >
      <div className="tds-modal__dialog-header">
        <h2 className="tds-modal__dialog-title" id={ id + '-heading' }>
          Photo Preview
        </h2>
      </div>
      <div className="tds-modal__dialog-body">
        <div className="tds-modal__dialog-body-content">
          <ImageDiv>
            <Image alt={alt} src={src} className="tlPrivate" />
          </ImageDiv>
        </div>
      </div>
      <div className="tds-modal__dialog-footer">
			<div className="tds-modal__dialog-button-container">
				<div className="tds-modal__dialog-button-layout">
					<button
            className="tds-button--primary tds-button--small"
            onClick={handleClose}
            data-dismiss="modal"
          >
            Close Preview
          </button>
				</div>
			</div>
		</div>
    <button
      className="tds-modal__dismiss"
      aria-label="Dismiss dialog"
      onClick={handleClose}
      type="button"
    >
        <svg focusable="false">
          <use href="/claimuploadcenter/icons/symbol-sprites.svg#x-1-12"></use>
        </svg>
      </button>
    </div>
  </div>

)

export { PhotoPreview }
